module.exports = __webpack_public_path__ + "img/3.c0c91a6b.jpg";